import styled from 'styled-components';

export const ContentHubContent = styled.div`
  padding-bottom: 24px;
  padding-left: ${({ noPadding }) => (noPadding ? '0px' : '15px')};
  padding-right: ${({ noPadding }) => (noPadding ? '0px' : '15px')};
`;

export const ContentHubHeadline = styled.div`
  color: ${(props) => props.theme.color.primary800};
  font-family: ${(props) => props.theme.font.bold};
  font-size: 26px;
  line-height: 36px;
  margin-top: 24px;
  margin-bottom: 12px;
  overflow: hidden;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  white-space: pre-wrap;

  a,
  span {
    color: ${(props) => props.theme.color.primary800} !important;
    text-decoration: none;
  }

  @media (${(props) => props.theme.contentHub.mobileSwitch}) {
    font-size: 18px;
    line-height: 25px;
  }
`;

export const ContentHubColorLine = styled.div`
  border-bottom: ${(props) =>
    `solid 1px ${props.theme.designTokens.colors.jade.jade60}`};
  margin: 10px 0px;
  width: 75px;
  height: 0px;
`;

export const ContentHubImage = styled.div`
  font-family: ${(props) => props.theme.font.regular};
  cursor: ${({ inHero }) => (inHero ? 'inherit' : 'pointer')};
`;

export const ContentHubDescription = styled.a`
  color: ${(props) => props.theme.designTokens.colors.grey.grey60};
  font-size: 16px;
  line-height: 24px;
  font-weight: 400;
  margin-top: 12px;
  margin-bottom: 24px;
  overflow: hidden;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 3;
  white-space: pre-wrap;
  text-decoration: none;
`;

export const ContentHubTopic = styled.div`
  font-family: ${(props) => props.theme.font.bold};
  font-size: 14px;
  line-height: 20px;
  text-transform: uppercase;
  text-decoration: none;

  & span {
    color: ${(props) => props.theme.color.gray600} !important;
  }
`;

export const ContentHubTopicLink = styled.div`
  & a {
    font-family: ${(props) => props.theme.font.bold};
    font-size: 14px;
    line-height: 20px;
    text-transform: uppercase;
    text-decoration: none;
    padding: 0px;
  }

  & span {
    padding-bottom: 1px;
  }
`;

export const ContentHubType = styled.div`
  font-family: ${(props) => props.theme.font.regular};
  font-size: 14px;
  line-height: 20px;
  text-transform: capitalize;
  display: flex;
  align-items: center;
  margin-top: 5px;

  &:first-letter {
    text-transform: capitalize;
  }
  & span {
    color: ${(props) => props.theme.color.gray600} !important;
    margin-top: 0px;
  }
`;

export const ContentHubTypeSeparator = styled.span`
  margin-right: 5px;
  margin-left: 5px;
  color: #6b6b6b !important;
`;

export const ContentHubTypeIcon = styled.span`
  display: flex;
`;
